<template>
  <div class="md-layout">
    <div class="md-layout-item asset-container">
      <div class="md-layout md-alignment-left">
        <md-checkbox
          class="md-layout-item md-small-size-100 md-size-20"
          v-model="asset.has_income"
          :disabled="asset_type_properties.has_income !== null"
          >Income</md-checkbox
        >

        <md-checkbox
          class="md-layout-item md-small-size-100 md-size-20"
          v-model="asset.has_trade_in"
          :disabled="asset_type_properties.has_trade_in !== null"
          ><span style="white-space: nowrap">Trade In</span></md-checkbox
        >
      </div>
      <div class="md-layout">
      <!-- Type -->
        <validated-autocomplete-input
          :class="class30"
          label="Type"
          v-model="asset.type"
          :prefixLabel="prefixLabel"
          :options="options.asset_type_options"
          required
          force
        />

        <!-- Asset Value -->
        <validated-input
          type="CURRENCY"
          v-if="!isCreditCard"
          :class="class20"
          label="Asset Value"
          :prefixLabel="prefixLabel"
          prefix="$"
          v-model="trade_in_asset_value"
          :disabled="!asset.has_value"
        />

        <!-- Asset Description -->
        <validated-text-input
          v-if="!isCreditCard"
          :class="class30"
          v-model="asset.description"
          :label="isCar ? 'Description(Model)' : 'Description'"
          :prefixLabel="prefixLabel"
        />

        <!-- Asset Description -->
        <validated-text-input
          type="YEAR"
          v-if="isCar"
          :class="class20"
          v-model="asset.years"
          label="Year"
          :prefixLabel="prefixLabel"
        />
      </div>
      <div class="md-layout" v-if="asset.has_income">
        <!-- Income Amount -->
        <validated-input
          type="CURRENCY"
          class="md-layout-item md-small-size-100 md-size-40"
          label="Income"
          :prefixLabel="prefixLabel"
          prefix="$"
          v-model="asset.income.amount"
          :suffix="toMonthlyAmount(asset.income.amount, asset.income.frequency, true) +'/m'"
        />

        <!-- Income Frequency -->
        <validated-autocomplete-input
          class="md-layout-item md-small-size-100 md-size-35"
          label="Frequency"
          v-model="asset.income.frequency"
          :prefixLabel="prefixLabel"
          :options="options.payment_frequency_options"
          force
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import filters from "@/components/utils/filters";
import utils from "@/components/utils/utils";
import ValidatedInputs from "@/components/ValidatedInput";
import ListItemCard from "@/components/Cards/ListItemCard.vue";

export default {
  components: {
    ...ValidatedInputs,
    ListItemCard,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    duration: {
      type: Boolean,
      default: false,
    },
    ownership: {
      type: Boolean,
      default: false,
    },
    prefixLabel: {
      type: String,
      default: "Asset",
    },
    index: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      class20: "md-layout-item md-small-size-100 md-size-20",
      class30: "md-layout-item md-small-size-100 md-size-30",
      class40: "md-layout-item md-small-size-100 md-size-40",
      class50: "md-layout-item md-small-size-100 md-size-50",
      class60: "md-layout-item md-small-size-100 md-size-60",
    };
  },
  watch: {
    "asset.type"(newAssetType , oldAssetType) {
      if(oldAssetType && oldAssetType.length > 0 && newAssetType && newAssetType.length > 0){
        this.$emit('change-asset',{ asset : this.asset , newAssetType , index:this.index })
      }
      this.matchAssetsHasToType();
    },
    "asset.has_trade_in"(has_trade_in) {
      if (has_trade_in) {
        this.$emit("set-as-trade-in");
      }
    },
  },
  computed: {
    // standard list of options from store
    ...mapGetters(["options", "properties", "security"]),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    asset: {
      get() {
        return this.value;
      },
      set(asset) {
        this.$emit("input", asset);
      },
    },

    asset_type_properties() {
      let properties =
        this.properties.asset_type_properties &&
        this.properties.asset_type_properties[this.asset.type];
      if (properties) {
        return properties;
      } else {
        return {
          has_value: false,
          has_income: false,
        };
      }
    },
    isCreditCard() {
      return this.asset.type == "Credit Card";
    },
    isCar() {
      return this.asset.type == "Car";
    },
    //get and set the trade in value
    trade_in_asset_value: {
      get() {
        return this.asset.has_trade_in && this.asset.value === null
          ? this.security.trade_in_value
          : this.asset.value;
      },
      set(value) {
        this.security.trade_in_value = value;
        this.asset.value = value;
      },
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,
    ...utils,

    matchAssetsHasToType() {
      // set has_asset to the types default
      if (this.asset_type_properties.has_value !== null) {
        this.asset.has_value = this.asset_type_properties.has_value;
      }
      // set has_income to the types default
      if (this.asset_type_properties.has_income !== null) {
        this.asset.has_income = this.asset_type_properties.has_income;
      }
      // set has_trade_in to the types default
      if (this.asset_type_properties.has_trade_in !== null) {
        this.asset.has_trade_in = this.asset_type_properties.has_trade_in;
      }
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  async beforeCreate() {
    const params = {
      types: [
        'asset_type_options',
        'asset_type_properties',
        'payment_frequency_options',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
  created() {
    this.matchAssetsHasToType();
    // for existing applications where the trade in value in asset is not set
    if (
      this.security.trade_in_value > 0 &&
      (this.asset.value == 0 || this.asset.value == null) &&
      this.asset.has_trade_in
    ) {
      this.asset.value = this.security.trade_in_value;
    }
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";

.asset-container{
  padding:0px; 
}

.divide-right {
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
